import React, { FC, useRef, useState } from "react";
import PropTypes from "prop-types";
import { PersonalInfoStyle } from "../Styles/ProfilePagesStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Container, Grid } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import AdminHeader from "../SubComponents/AdminHeader";
import Footer from "../SubComponents/Footer";
import PersonalInfoTab from "./PersonalInfoTab";
import TwoFactorTab from "./TwoFactorTab";
import MobileBullets from "../SubComponents/MobileBullets";
import { TabsProps } from "../../interfaces";
import IdentityVerificationTab from "./IdentityVerificationTab";
import { RouteComponentProps } from "react-router";
import BackButton from "../../helpers/BackButton";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";

const TabPanel: FC<TabsProps> = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index: number) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const PersonalInfo: FC<RouteComponentProps<{ tabIndex?: string }>> = ({
  match,
}) => {
  const initialTabIndex = match.params.tabIndex
    ? parseInt(match.params.tabIndex, 10)
    : 0;

  const classes = PersonalInfoStyle();
  const theme = useTheme();
  const [value, setValue] = useState(initialTabIndex);
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const isActiveXS = useMediaQuery(theme.breakpoints.down("xs"));

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  const scrolldiv = useRef(null);

  return (
    <>
      <AdminHeader />
      <Box className={classes.profilesetting} component="section">
        <Container fixed>
          <BackButton goBack />
          <Grid>
            <Grid item md={12}>
              <Box mb={isActiveXS ? 3 : 5} p={0}>
                <ProjectPoolHeading title1="Profile" title2="Settings" />
              </Box>
              <div id="scrolldiv" ref={scrolldiv} className={classes.root}>
                <Tabs
                  value={value}
                  textColor="secondary"
                  indicatorColor="secondary"
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons={isActive ? "on" : "off"}
                  aria-label="scrollable auto tabs example"
                >
                  <Tab label="KYC" {...a11yProps(0)} />
                  <Tab label="Personal" {...a11yProps(1)} />
                  <Tab label="Privacy & Security" {...a11yProps(2)} />
                </Tabs>

                <TabPanel value={value} index={0}>
                  <IdentityVerificationTab />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <PersonalInfoTab />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <TwoFactorTab />
                </TabPanel>
              </div>
              {/** tab small button */}
              {isActive ? (
                <Box mt={2}>
                  <MobileBullets
                    value={value}
                    handleChange={handleChange}
                    bullets={[1, 2, 3]}
                    scroll={scrolldiv}
                  />
                </Box>
              ) : (
                ""
              )}
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
    </>
  );
};
export default PersonalInfo;
